import { AutomationStatus, WeekDay } from 'common/api-types/ordering-automation';

export const HOURS_OPTIONS = Array.from({ length: 24 }, (_, i) => i);
export const MINUTES_OPTIONS = Array.from({ length: 4 }, (_, i) => i * 15);

export const WEEKDAYS: WeekDay[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export const AUTOMATION_STATUSES: AutomationStatus[] = [
  'FULLY_AUTOMATED',
  'PARTIALLY_AUTOMATED',
  'NOT_AUTOMATED',
];
